import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "table-wrapper" }
const _hoisted_2 = { class: "user-table" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "th-inner" }
const _hoisted_5 = {
  key: 0,
  class: "sort-indicator"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "col-id"
}
const _hoisted_8 = { class: "id-cell" }
const _hoisted_9 = {
  key: 1,
  class: "col-username"
}
const _hoisted_10 = { class: "username-link" }
const _hoisted_11 = {
  key: 2,
  class: "col-fullName"
}
const _hoisted_12 = {
  key: 3,
  class: "col-createdAt"
}
const _hoisted_13 = { class: "muted" }
const _hoisted_14 = {
  key: 4,
  class: "col-isActive"
}
const _hoisted_15 = {
  key: 5,
  class: "col-isLoggedIn"
}
const _hoisted_16 = {
  key: 6,
  class: "col-action"
}
const _hoisted_17 = ["href", "onClick"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["colspan"]

import { computed, ref } from "vue";
import type { User } from "@/types/user";
import BaseIcon from "@/components/ui/BaseIcon.vue";

export type ColumnKey =
  | "id"
  | "username"
  | "fullName"
  | "createdAt"
  | "isActive"
  | "isLoggedIn"
  | "action";

type SortDir = "asc" | "desc";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserTable',
  props: {
    users: {},
    columns: {}
  },
  setup(__props: any) {

const props = __props;

const columnLabels: Record<ColumnKey, string> = {
  id: "ID",
  username: "Username",
  fullName: "Full Name",
  createdAt: "Created At",
  isActive: "Active",
  isLoggedIn: "Logged In",
  action: "Action",
};

const sortableColumns: ColumnKey[] = [
  "id",
  "username",
  "fullName",
  "createdAt",
  "isActive",
  "isLoggedIn",
];

const sortKey = ref<ColumnKey>("id");
const sortDir = ref<SortDir>("asc");

function toggleSort(col: ColumnKey) {
  if (!sortableColumns.includes(col)) return;
  if (sortKey.value === col) {
    sortDir.value = sortDir.value === "asc" ? "desc" : "asc";
  } else {
    sortKey.value = col;
    sortDir.value = "asc";
  }
}

const sortedUsers = computed(() => {
  return [...props.users].sort((a, b) => {
    const key = sortKey.value;
    const dir = sortDir.value === "asc" ? 1 : -1;

    const aVal = a[key as keyof User];
    const bVal = b[key as keyof User];

    if (typeof aVal === "boolean" && typeof bVal === "boolean") {
      return (Number(aVal) - Number(bVal)) * dir;
    }

    if (typeof aVal === "number" && typeof bVal === "number") {
      return (aVal - bVal) * dir;
    }

    return String(aVal).localeCompare(String(bVal)) * dir;
  });
});

function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

function userPath(id: number): string {
  return `/users/${id}`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (col) => {
            return (_openBlock(), _createElementBlock("th", {
              key: col,
              class: _normalizeClass([
              'col-' + col,
              sortableColumns.includes(col) && 'sortable',
              sortKey.value === col && 'sort-active',
            ]),
              onClick: ($event: any) => (toggleSort(col))
            }, [
              _createElementVNode("span", _hoisted_4, [
                _createTextVNode(_toDisplayString(columnLabels[col]) + " ", 1),
                (sortableColumns.includes(col))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                      (sortKey.value === col && sortDir.value === 'asc')
                        ? (_openBlock(), _createBlock(BaseIcon, {
                            key: 0,
                            name: "chevron-up",
                            size: 10,
                            "stroke-width": 2.5
                          }))
                        : (sortKey.value === col && sortDir.value === 'desc')
                          ? (_openBlock(), _createBlock(BaseIcon, {
                              key: 1,
                              name: "chevron-down",
                              size: 10,
                              "stroke-width": 2.5
                            }))
                          : (_openBlock(), _createBlock(BaseIcon, {
                              key: 2,
                              name: "chevron-up",
                              size: 10,
                              "stroke-width": 2.5,
                              class: "sort-idle"
                            }))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_3))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedUsers.value, (user) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: user.id,
            class: "clickable-row",
            onClick: ($event: any) => (_ctx.$router.push(userPath(user.id)))
          }, [
            (__props.columns.includes('id'))
              ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, "# " + _toDisplayString(user.id), 1)
                ]))
              : _createCommentVNode("", true),
            (__props.columns.includes('username'))
              ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(user.username), 1)
                ]))
              : _createCommentVNode("", true),
            (__props.columns.includes('fullName'))
              ? (_openBlock(), _createElementBlock("td", _hoisted_11, _toDisplayString(user.fullName), 1))
              : _createCommentVNode("", true),
            (__props.columns.includes('createdAt'))
              ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(formatDate(user.createdAt)), 1)
                ]))
              : _createCommentVNode("", true),
            (__props.columns.includes('isActive'))
              ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                  _createElementVNode("span", {
                    class: _normalizeClass(['status-badge', user.isActive ? 'active' : 'inactive'])
                  }, _toDisplayString(user.isActive ? "Active" : "Inactive"), 3)
                ]))
              : _createCommentVNode("", true),
            (__props.columns.includes('isLoggedIn'))
              ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                  _createElementVNode("span", {
                    class: _normalizeClass(['loggedin-badge', user.isLoggedIn ? 'yes' : 'no'])
                  }, _toDisplayString(user.isLoggedIn ? "Yes" : "No"), 3)
                ]))
              : _createCommentVNode("", true),
            (__props.columns.includes('action'))
              ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                  _createElementVNode("a", {
                    href: userPath(user.id),
                    class: "action-btn",
                    onClick: _withModifiers(($event: any) => (_ctx.$router.push(userPath(user.id))), ["stop"])
                  }, [
                    _createVNode(BaseIcon, {
                      name: "external-link",
                      size: 14
                    })
                  ], 8, _hoisted_17)
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_6))
        }), 128)),
        (sortedUsers.value.length === 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
              _createElementVNode("td", {
                colspan: __props.columns.length,
                class: "empty-state"
              }, "No users found.", 8, _hoisted_19)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})